/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Site } from '@api/model';
import { IAction } from '../../models/IshAction';
import { GET_SITES_FULFILLED } from '../actions/Sites';

const Initial: Site[] = [];

export const sitesReducer = (state: Site[] = Initial, action: IAction): Site[] => {
  switch (action.type) {
    case GET_SITES_FULFILLED:
      return [...action.payload];
    default:
      return [...state];
  }
};
